/** Controla si la fecha es posterior a la actual */
export function checkExpirationDate(date?: string | undefined) {
  if (!date || date.trim().length === 0) return false;

  let expirationDate = undefined;
  try {
    expirationDate = Date.parse(date);
  } catch (e) {}

  return expirationDate != null && Date.now() < expirationDate;
}
